module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_9-99abba6c0f501b47c14d4dccb42963d4.jpg";